import { useApiState } from '@flowus/common/hooks/use-api-state';
import { request } from 'src/common/request';

export const useWallet = () => {
  return useApiState({
    getApi: request.infra.totalDistributionAllianceVipInWallet,
    enable: !__BUILD_IN__ && !__PRIVATE__,
  });
};
